import React from 'react';
import './AudioIndicator.scss';

interface AudioIndicatorProps {
    type?: 'shared' | 'question';
}

export const AudioIndicator: React.FC<AudioIndicatorProps> = ({ type = 'shared' }) => {
    return (
        <div className={type === 'shared' ? 'AudioIndicator' : 'QuestionAudioIndicator'}>
            <span className="AudioIcon">{type === 'shared' ? "🎧" : "🔊"}</span>
            <span className="AudioText">
                {type === 'shared' 
                    ? "Audio will play automatically" 
                    : "Audio for this question"}
            </span>
        </div>
    );
};